import { FC } from 'react';
import { Link, Outlet } from 'react-router';

import { Carousel } from 'components/UI/Carousel';
import { Footer } from 'components/UI/Footer';
import { LanguageSelector } from 'components/UI/LanguageSelector';
import * as routes from 'router/routes';
import { PageContainer, Header, HeaderLogo, Main, Content } from './styled';

export const PublicPageWrapper: FC = () => {
  return (
    <PageContainer>
      <Content>
        <Header>
          <Link to={routes.LOGIN}>
            <HeaderLogo />
          </Link>
          <LanguageSelector />
        </Header>
        <Main>
          <Outlet />
        </Main>
        <Footer />
      </Content>
      <Carousel />
    </PageContainer>
  );
};
